/**
 * 活动报名相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/paper/info/activity/queryPage',
                data
            })
        },
        removeInfo(data) {
            return http.json({
              url: `/paper/info/deleteInfoAndChildrenTitle?id=${data.id}`,
              data,
            });
          },

          activityBindQuery(){
            return http.json({
                url: '/paper/info/activity/bindQuery'
            })
          },
          removeInfo(data) {
            return http.json({
              url: `/paper/info/deleteActivityPaper?id=${data.id}`,
              data,
            });
          },
          

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/paperActivity.js